import request from 'src/api'
import deleteRecord from 'src/deleteRecord'
import { addToast } from 'src/toasts'
import { lockButton } from 'src/lockButton'
import { handleErrors } from 'src/errors'
import { contractPeopleFunctions } from 'packs/contract_people/functions'
import initDatatableChrome from 'src/datatableChrome'
import onIndexRefresh from 'src/indexRefresh'

export default () => {
  contractPeopleFunctions()

	// datatable init
  let contractPeopleDatatable = $('#contract-people-datatable').DataTable({
    "language": {
      url: "/datatable_i18n"
    },
    "pageLength": (localStorage.getItem('contractPeopleIndexPageLength') || 25),
    "processing": true,
    // TODO.md F-123. A control COLUMN, not Responsive's default inline control. `'inline'` puts the expand
    // control in the FIRST cell — the same cell as the record's own link — so at phone width the two shared
    // one tap target and tapping the arrow opened the record. `target: 0` is the column added by
    // `shared/_datatable_control_th`.
    // ⚠️ The `dtr-control` className below is NOT optional: `Responsive._controlClass` (dataTables.responsive.js:674,
    // v2.5.1) runs its body only when `details.type === 'inline'`, so under `'column'` nothing adds it.
    // 🚨 **TODO.md F-123 follow-up. An EXPLICIT sort, because the control column silently removed it.**
    // DataTables' default is `aaSorting: [[0, 'asc']]` (`jquery.dataTables.js:10285`) and none of these
    // packs set `order`, so inserting the non-orderable control column at index 0 made the request carry
    // `order[0][column]=0`. `_fnSortFlatten` does not filter on `bSortable`, `ajax-datatables-rails` adds a
    // sort clause only `if column.orderable?` (`orm/active_record.rb:15`), and the resulting
    // `order(Arel.sql(''))` is dropped by Rails 8.1's `compact_blank` — verified:
    // `Customer.order(Arel.sql("")).limit(25).to_sql` has no ORDER BY at all.
    // ⚠️ **The lost alphabetical default was the visible half; the unstable paging was the dangerous one** —
    // server-side `LIMIT/OFFSET` with no ORDER BY can repeat or skip rows between pages.
    // 📌 Found by `/code-review` after the branch had already merged, which is why `spec/config/
    // datatable_responsive_spec.rb` now asserts an explicit non-zero `order` as part of the same rule.
    "order": [[1, "asc"]],
    "responsive": { "details": { "type": "column", "target": 0 } },
    "serverSide": true,
    "ajax": {
      "url": $('#contract-people-datatable').data('source')
    },
    "columns": [
      { "data": "control", "orderable": false, "searchable": false, "className": "dtr-control" },
      { "data": "first_name" },
      { "data": "last_name" },
      { "data": "phone" },
      { "data": "customers" }
    ],
    initComplete(settings, json) {
      initDatatableChrome('contract-people-datatable')
  	}
  })

  // T-102 / T-108 / U-48: reload this page's table when a save says so. The `off()`/`on()` pair and
  // `resetPaging: false` live in `src/indexRefresh` — five packs carried a copy of both.
  onIndexRefresh('contractPeopleIndex', contractPeopleDatatable)

  $('#content').on('change', "[name='contract-people-datatable_length']", function() {
    localStorage.setItem('contractPeopleIndexPageLength', $(this).val())
  })

  $('.clear-button').on('click', function() {
    $('.clear-button').addClass('d-none')
    contractPeopleDatatable.search('').draw()
  })

  $('#content').on('click', '#add_contract_person', function() {
    lockButton('#add_contract_person')
    offcanvasRight.show()
    $.getScript('/contract_people/new')
  })

  $('#mainModal').on('click', '#confirmDelete', function(event) {
    $(this).blur()
    if ($("#basic-information").find('form').attr('action').includes('contract_people')) {
      lockButton('#confirmDelete')

      // T-111: `deleteRecord` clears `dirty` before this runs, which is what makes the close below safe —
      // `hide.bs.offcanvas` reads the flag and `hidden.bs.offcanvas` clears it only afterwards (F-148).
      deleteRecord($("#offcanvasRight .tab-pane.active form").attr('action'))
        .then(res => {
          addToast(res.body.success, 'notice')
          if (contractPeopleDatatable !== null) {
            contractPeopleDatatable.ajax.reload()
          }
          mainModal.hide()
          $('#offcanvasRight .btn-close').click()
        })
        .catch(err => {
          handleErrors(err, '#confirmDelete')
        })
    }
  })
}
